// extracted by mini-css-extract-plugin
export default {"full-height-wrap":"wrap_full-height-wrap__JH7ep","contents-wrap":"wrap_contents-wrap__6p5mD","actions-wrap":"wrap_actions-wrap__qFqsC"};